<template>
  <div class="p-5 h-full overflow-auto">
    <!-- En-tête avec actions -->
    <div class="flex justify-between items-center mb-6">
      <h1 class="text-2xl font-bold text-gray-800">Mon Profil & Paramètres</h1>
      <div class="flex gap-3">
        <button
          @click="saveSettings"
          class="buttonComponent bg-green-600 hover:bg-green-700 text-white"
          v-if="hasChanges"
        >
          <i class="pi pi-save mr-2"></i>
          Enregistrer
        </button>
      </div>
    </div>

    <!-- Sections des paramètres -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <!-- Paramètres généraux -->
      <div class="rounded-2xl border border-gray-200 bg-white p-6"
        v-if="false"
      >
        <h2
          class="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2"
        >
          <i class="pi pi-cog text-gray-600"></i>
          Paramètres généraux
        </h2>

        <div class="space-y-4">
          <div>
            <label class="mb-1.5 block text-sm font-medium text-gray-700">
              Nom de la plateforme
            </label>
            <input
              type="text"
              v-model="localSettings.platformName"
              class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs"
              placeholder="Rapidoo"
            />
          </div>

          <div>
            <label class="mb-1.5 block text-sm font-medium text-gray-700">
              Email de support
            </label>
            <input
              type="email"
              v-model="localSettings.supportEmail"
              class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs"
              placeholder="support@rapidoo.com"
            />
          </div>

          <div>
            <label class="mb-1.5 block text-sm font-medium text-gray-700">
              Téléphone de contact
            </label>
            <input
              type="tel"
              v-model="localSettings.contactPhone"
              class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs"
              placeholder="+225 00 00 00 00"
            />
          </div>

          <div>
            <label class="mb-1.5 block text-sm font-medium text-gray-700">
              Adresse
            </label>
            <textarea
              v-model="localSettings.address"
              class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs"
              placeholder="Adresse complète"
              rows="2"
            ></textarea>
          </div>
        </div>
      </div>

      <!-- Réseaux sociaux -->
      <div class="rounded-2xl border border-gray-200 bg-white p-6"
        v-if="false"
      >
        <h2
          class="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2"
        >
          <i class="pi pi-share-alt text-gray-600"></i>
          Réseaux sociaux
        </h2>

        <div class="space-y-4">
          <div>
            <label class="mb-1.5 block text-sm font-medium text-gray-700">
              Facebook
            </label>
            <input
              type="url"
              v-model="localSettings.socialMedia.facebook"
              class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs"
              placeholder="https://facebook.com/rapidoo"
            />
          </div>

          <div>
            <label class="mb-1.5 block text-sm font-medium text-gray-700">
              Instagram
            </label>
            <input
              type="url"
              v-model="localSettings.socialMedia.instagram"
              class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs"
              placeholder="https://instagram.com/rapidoo"
            />
          </div>

          <div>
            <label class="mb-1.5 block text-sm font-medium text-gray-700">
              Twitter / X
            </label>
            <input
              type="url"
              v-model="localSettings.socialMedia.twitter"
              class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs"
              placeholder="https://x.com/rapidoo"
            />
          </div>

          <div>
            <label class="mb-1.5 block text-sm font-medium text-gray-700">
              LinkedIn
            </label>
            <input
              type="url"
              v-model="localSettings.socialMedia.linkedin"
              class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs"
              placeholder="https://linkedin.com/company/rapidoo"
            />
          </div>

          <div>
            <label class="mb-1.5 block text-sm font-medium text-gray-700">
              WhatsApp (avec code pays)
            </label>
            <input
              type="tel"
              v-model="localSettings.socialMedia.whatsapp"
              class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs"
              placeholder="+2250700000000"
            />
          </div>

          <div>
            <label class="mb-1.5 block text-sm font-medium text-gray-700">
              YouTube
            </label>
            <input
              type="url"
              v-model="localSettings.socialMedia.youtube"
              class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs"
              placeholder="https://youtube.com/@rapidoo"
            />
          </div>
        </div>
      </div>

      <!-- Paramètres du système -->
      <div
        v-if="false"
        class="rounded-2xl border border-gray-200 bg-white p-6 lg:col-span-2"
      >
        <h2
          class="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2"
        >
          <i class="pi pi-server text-gray-600"></i>
          Paramètres système
        </h2>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div class="space-y-4">
            <div class="flex items-center gap-3">
              <input
                type="checkbox"
                v-model="localSettings.maintenanceMode"
                class="rounded"
              />
              <label class="text-sm font-medium text-gray-700">
                Mode maintenance
              </label>
            </div>

            <div class="flex items-center gap-3">
              <input
                type="checkbox"
                v-model="localSettings.debugMode"
                class="rounded"
              />
              <label class="text-sm font-medium text-gray-700">
                Mode debug
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- Section Super Admin : Sécurité & Mot de passe -->
      <div
        v-if="isSuperAdmin"
        class="rounded-2xl border border-amber-200 bg-amber-50/40 p-6 lg:col-span-2 shadow-sm"
      >
        <h2
          class="text-lg font-semibold text-gray-800 mb-2 flex items-center gap-2"
        >
          <i class="pi pi-shield text-amber-600"></i>
          Sécurité Super Admin - Modifier mon mot de passe
        </h2>
        <p class="text-xs text-gray-500 mb-4">
          Cette section est visible uniquement par le Super Administrateur ({{ currentUser?.email || 'Admin' }}).
        </p>

        <form @submit.prevent="updateMyPassword" class="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-4xl">
          <!-- Ancien mot de passe -->
          <div>
            <label class="mb-1.5 block text-sm font-medium text-gray-700">
              Ancien mot de passe
            </label>
            <div class="relative">
              <input
                required
                :type="showOldPassword ? 'text' : 'password'"
                v-model="passwordForm.oldPassword"
                placeholder="Votre mot de passe actuel"
                class="w-full rounded-lg border border-gray-300 bg-white px-4 py-2.5 pr-10 text-sm text-gray-800 shadow-theme-xs"
              />
              <button
                type="button"
                @click="showOldPassword = !showOldPassword"
                class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 focus:outline-none"
              >
                <i :class="showOldPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
              </button>
            </div>
          </div>

          <!-- Nouveau mot de passe -->
          <div>
            <label class="mb-1.5 block text-sm font-medium text-gray-700">
              Nouveau mot de passe
            </label>
            <div class="relative">
              <input
                required
                :type="showMyPassword ? 'text' : 'password'"
                v-model="passwordForm.newPassword"
                minlength="6"
                placeholder="Au moins 6 caractères"
                class="w-full rounded-lg border border-gray-300 bg-white px-4 py-2.5 pr-10 text-sm text-gray-800 shadow-theme-xs"
              />
              <button
                type="button"
                @click="showMyPassword = !showMyPassword"
                class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 focus:outline-none"
              >
                <i :class="showMyPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
              </button>
            </div>
          </div>

          <!-- Confirmer le mot de passe -->
          <div>
            <label class="mb-1.5 block text-sm font-medium text-gray-700">
              Confirmer le mot de passe
            </label>
            <div class="relative">
              <input
                required
                :type="showMyPassword ? 'text' : 'password'"
                v-model="passwordForm.confirmPassword"
                minlength="6"
                placeholder="Répétez le nouveau mot de passe"
                class="w-full rounded-lg border border-gray-300 bg-white px-4 py-2.5 pr-10 text-sm text-gray-800 shadow-theme-xs"
              />
            </div>
          </div>

          <div class="md:col-span-3 flex justify-end mt-2">
            <button
              type="submit"
              :disabled="isUpdatingPassword"
              class="buttonComponent bg-amber-600 hover:bg-amber-700 text-white rounded-lg px-5 py-2.5 text-sm font-medium"
            >
              <i class="pi pi-key mr-2"></i>
              {{ isUpdatingPassword ? 'Vérification et mise à jour...' : 'Mettre à jour mon mot de passe' }}
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- Modal de confirmation -->
    <div
      v-if="showSaveModal"
      class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
    >
      <div class="bg-white rounded-xl p-6 max-w-md w-full mx-4">
        <h3 class="text-lg font-semibold text-gray-800 mb-4">
          Confirmer la sauvegarde
        </h3>
        <p class="text-gray-600 mb-6">
          Voulez-vous enregistrer les modifications apportées aux paramètres de
          la plateforme ?
        </p>
        <div class="flex gap-3">
          <button
            @click="confirmSave"
            class="flex-1 buttonComponent bg-green-600 hover:bg-green-700 text-white"
            :disabled="isSaving"
          >
            <i class="pi pi-check mr-2"></i>
            {{ isSaving ? 'Sauvegarde...' : 'Confirmer' }}
          </button>
          <button
            @click="showSaveModal = false"
            class="flex-1 buttonComponent border border-gray-300 text-gray-700"
            :disabled="isSaving"
          >
            Annuler
          </button>
        </div>
      </div>
    </div>

    <!-- DataFetcher pour charger les paramètres -->
    <div class="hidden">
      <DataFetcher
        dataKey="generalAppSettings"
        @fetched="({ data }) => loadSettings(data)"
      />
    </div>

    <!-- ActionTrigger pour la sauvegarde -->
    <ActionTrigger
      dataKey="saveGeneralAppSettings"
      ref="saveSettingsTrigger"
      @success="onSaveSuccess"
      @failed="onSaveError"
    />
  </div>
</template>

<script setup>
import { ref, reactive, computed } from 'vue'
import DataFetcher from '@/features/data/presentation/components/DataFetcher.vue'
import Events from '@/events/events'
import { EVENTS } from '@/shared/constants/commons'
import Commons from '@/shared/utils/commons'
import AuthService from '@/features/auth/authService'
import DataService from '@/features/data/dataService'

const saveSettingsTrigger = ref(null)
const showSaveModal = ref(false)
const isSaving = ref(false)

// Authentification & Super Admin
const currentUser = computed(() => AuthService.getUserData(true)?.value)
const isSuperAdmin = computed(() => {
  const user = currentUser.value
  return user?.role === 'super-admin' || user?.role === 'admin' || user?.isSuperAdmin === true
})

const passwordForm = reactive({
  oldPassword: '',
  newPassword: '',
  confirmPassword: '',
})
const showOldPassword = ref(false)
const showMyPassword = ref(false)
const isUpdatingPassword = ref(false)

async function verifyOldPassword(email, oldPassword) {
  try {
    const { USER_API_CONFIG } = await import('@/project/configs/api.js')
    const loginUrl = `${USER_API_CONFIG.baseURL}/${USER_API_CONFIG.serviceName}/login?group=${USER_API_CONFIG.serviceGroup}`
    const res = await fetch(loginUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password: oldPassword }),
    })
    const data = await res.json()
    return data.statusCode === 200 || (data.data && data.data.id)
  } catch (e) {
    console.error('Failed to verify old password:', e)
    return false
  }
}

async function updateMyPassword() {
  const email = currentUser.value?.email
  if (!email) {
    Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
      title: 'Erreur',
      body: 'Utilisateur introuvable.',
      type: 'error',
    })
    return
  }

  if (!passwordForm.oldPassword) {
    Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
      title: 'Erreur',
      body: "Veuillez renseigner votre mot de passe actuel.",
      type: 'error',
    })
    return
  }

  if (passwordForm.newPassword !== passwordForm.confirmPassword) {
    Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
      title: 'Erreur',
      body: 'Les nouveaux mots de passe ne correspondent pas.',
      type: 'error',
    })
    return
  }

  if (passwordForm.newPassword.length < 6) {
    Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
      title: 'Erreur',
      body: 'Le nouveau mot de passe doit comporter au moins 6 caractères.',
      type: 'error',
    })
    return
  }

  if (passwordForm.oldPassword === passwordForm.newPassword) {
    Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
      title: 'Erreur',
      body: 'Le nouveau mot de passe doit être différent de l\'ancien mot de passe.',
      type: 'error',
    })
    return
  }

  isUpdatingPassword.value = true
  try {
    // 1. Vérification de l'ancien mot de passe via login
    const isOldPasswordValid = await verifyOldPassword(email, passwordForm.oldPassword)
    if (!isOldPasswordValid) {
      Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
        title: 'Erreur',
        body: "L'ancien mot de passe est incorrect.",
        type: 'error',
      })
      isUpdatingPassword.value = false
      return
    }

    // 2. Mise à jour avec le nouveau mot de passe
    const user = currentUser.value
    const updateRes = await DataService.triggerAction('updateAdminUser', {
      email,
      firstName: user.firstName || 'Super',
      lastName: user.lastName || 'Admin',
      password: passwordForm.newPassword,
    })

    if (updateRes && updateRes.statusCode === 200) {
      passwordForm.oldPassword = ''
      passwordForm.newPassword = ''
      passwordForm.confirmPassword = ''
      Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
        title: 'Succès',
        body: 'Votre mot de passe a été modifié avec succès.',
        type: 'success',
      })
    } else {
      Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
        title: 'Erreur',
        body: updateRes?.message || 'Erreur lors de la modification du mot de passe.',
        type: 'error',
      })
    }
  } catch (err) {
    console.error(err)
    Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
      title: 'Erreur',
      body: 'Une erreur inattendue est survenue.',
      type: 'error',
    })
  } finally {
    isUpdatingPassword.value = false
  }
}

// État local des paramètres
const localSettings = reactive({
  // Paramètres généraux
  platformName: '',
  supportEmail: '',
  contactPhone: '',
  address: '',

  // Réseaux sociaux
  socialMedia: {
    facebook: '',
    instagram: '',
    twitter: '',
    linkedin: '',
    whatsapp: '',
    youtube: '',
  },

  // Paramètres système
  maintenanceMode: false,
  debugMode: false,
})

// Paramètres originaux pour comparer les changements
const originalSettings = ref(null) // null tant que pas chargé depuis l'API

// Détecter les changements
const hasChanges = computed(() => {
  if (originalSettings.value === null) return false // Pas de chargement = pas de changements
  return !Commons.deepEqual(localSettings, originalSettings.value)
})

// Charger les paramètres existants
function loadSettings(settingsData) {
  if (settingsData && Object.keys(settingsData).length) {
    Object.assign(localSettings, settingsData)
    originalSettings.value = JSON.parse(JSON.stringify(localSettings))
  }
}

// Sauvegarder les paramètres
function saveSettings() {
  if (!hasChanges.value) return
  showSaveModal.value = true
}

function confirmSave() {
  isSaving.value = true
  saveSettingsTrigger.value.trigger(localSettings)
}

function onSaveSuccess() {
  isSaving.value = false
  showSaveModal.value = false
  originalSettings.value = JSON.parse(JSON.stringify(localSettings))

  Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
    title: 'Succès',
    body: 'Les paramètres ont été sauvegardés avec succès',
  })
}

function onSaveError(error) {
  isSaving.value = false

  Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
    title: 'Erreur',
    body:
      error.result?.message || 'Une erreur est survenue lors de la sauvegarde',
  })
}
</script>

<style scoped></style>
